import { useState } from 'react';
import useWindowSize from '../hooks/useWindowSize';

const MobileOptimizedTextarea = ({
  name,
  value,
  onChange,
  placeholder,
  label,
  error,
  required = false,
  disabled = false,
  rows = 4,
  maxLength,
  className = '',
  style = {},
  showCharCount = false,
  ...props
}) => {
  const { isMobile } = useWindowSize();
  const [isFocused, setIsFocused] = useState(false);

  const baseTextareaStyle = {
    width: '100%',
    padding: isMobile ? '16px 20px' : '12px 16px',
    fontSize: isMobile ? '16px' : '14px', // 16px previene zoom en iOS
    lineHeight: '1.5',
    border: `2px solid ${error ? '#dc3545' : isFocused ? '#4352A9' : '#e1e5e9'}`,
    borderRadius: '8px',
    backgroundColor: disabled ? '#f8f9fa' : '#ffffff',
    color: disabled ? '#6c757d' : '#212529',
    transition: 'all 0.3s ease',
    outline: 'none',
    fontFamily: 'inherit',
    minHeight: isMobile ? '120px' : '100px',
    resize: 'vertical',
    boxSizing: 'border-box',
    ...style,
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '8px',
    fontSize: isMobile ? '16px' : '14px',
    fontWeight: '600',
    color: error ? '#dc3545' : '#495057',
    lineHeight: '1.4',
  };

  const errorStyle = {
    display: 'block',
    marginTop: '6px',
    fontSize: isMobile ? '14px' : '12px',
    color: '#dc3545',
    lineHeight: '1.4',
  };

  const charCountStyle = {
    display: 'block',
    marginTop: '6px',
    fontSize: isMobile ? '13px' : '12px',
    color: maxLength && value && value.length > maxLength * 0.9 ? '#ffc107' : '#6c757d',
    textAlign: 'right',
    lineHeight: '1.4',
  };

  const containerStyle = {
    position: 'relative',
    marginBottom: '20px',
    width: '100%',
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    if (props.onFocus) props.onFocus(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (props.onBlur) props.onBlur(e);
  };

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  // Optimizaciones específicas para móviles
  const mobileProps = isMobile ? {
    autoCapitalize: 'sentences',
    autoCorrect: 'on',
    spellCheck: 'true',
  } : {};

  return (
    <div style={containerStyle} className={className}>
      {label && (
        <label htmlFor={name} style={labelStyle}>
          {label}
          {required && <span style={{ color: '#dc3545', marginLeft: '4px' }}>*</span>}
        </label>
      )}
      
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        style={baseTextareaStyle}
        {...mobileProps}
        {...props}
      />
      
      {showCharCount && maxLength && (
        <span style={charCountStyle}>
          {value ? value.length : 0} / {maxLength}
        </span>
      )}
      
      {error && (
        <span style={errorStyle} role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default MobileOptimizedTextarea;
